module.exports = __webpack_public_path__ + "node_modules/drmonty-chosen/css/chosen-sprite@2x.png";


//////////////////
// WEBPACK FOOTER
// ./~/drmonty-chosen/css/chosen-sprite@2x.png
// module id = 673
// module chunks = 0